import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Workflow } from '../model/workflow';

@Injectable({
    providedIn: 'root'
  })
  export class WorkflowService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllWorkflows() 
    {
      return this._restClientService.load<Workflow[]>('workflow/workflows');
    }
    
    getWorkflowsByCategorie(categorie) 
    {
      return this._restClientService.load<Workflow[]>('workflow/workflows-by-categorie?categorie='+categorie);
    }
    
    getWorkflowByWorkflowCode(workflowcode) 
    {
      return this._restClientService.load<Workflow>('workflow/workflow-by-code?workflowcode='+workflowcode);
    }
    
  
}      

    